import React from 'react'
import useCourseDropability from './use-course-dropability'

const DropabilityLabel = ({
    experience = {}
}) => {
    const { reason } = useCourseDropability({ courseId: experience.id })
    if (!reason) {
        return null
    }
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                paddingTop: '10px'
            }}
            className='text-center'
        >
            <small>{reason}</small>
        </div>
    )
}

export default DropabilityLabel
